// Module
var code = "<div class=\"md-checkbox\"> <input type=\"checkbox\" id=\"minimize-maximize\" class=\"md-check\"> <label for=\"minimize-maximize\" class=\"col-md-offset-1 col-md-11\"> <span class=\"inc\"></span> <span class=\"check\"></span> <span class=\"box\"></span> Minimize/Maximize </label> </div>";
// Exports
export default code;